<template>
  <div>
    <Modal v-model="show" :title="type == 'add' ? $t('add') : $t('edit')" :mask-closable="false" width="1200"
      @on-cancel="cancel">
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" :label-width="155" label-colon>
          <Tabs :value="tabs" @on-click="ontabs" :animated="false">
            <Row :gutter="15" class="list">
              <TabPane :label="$t('Langue.zn')" name="1">
                <Col span="24" style="display: flex;">
                <Col span="12">
                <FormItem class="item_input" prop="zh-cn_title" :label="$t('title')">
                  <Input type="text" v-model="form['zh-cn_title']" placeholder="请输入标题"></Input>
                </FormItem>
                <FormItem class="item_input" prop="zh-cn_brief" :label="$t('brief')">
                  <Input type="text" v-model="form['zh-cn_brief']" placeholder="请输入简介"></Input>
                </FormItem>
                <FormItem class="item_input" prop="author" :label="$t('author')">
                  <Input type="text" v-model="form.author" placeholder="请输入作者"></Input>
                </FormItem>
                <FormItem :label="$t('img_lnk') + ' - PC'" prop="zh-cn_head_image">
                  <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 1)"
                    type="drag" action style="display: inline-block;width:300px;height: 150px;">
                    <div class="demo-upload-list" v-if="form['zh-cn_head_image'] != ''">
                      <template>
                        <img :src="form['zh-cn_head_image']" />
                      </template>
                    </div>
                    <div v-else style="width: 300px;height:150px;line-height: 165px;">
                      <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                    </div>
                  </Upload>
                  <div class="photo_tip">{{ $t('photo_tip') + " 1200 x 630" }}</div>
                  <div>
                    <Button type="primary" @click="onCopyImgPc(1)">{{ $t('Copy_language') }}</Button>
                  </div>
                </FormItem>
                <!-- <FormItem :label="$t('Details_pictures')+' - PC' " prop="zh-cn_detail_image">
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :before-upload="(value)=>handleBeforeUpload(value,4)"
                        type="drag"
                        action
                        style="display: inline-block;width:300px;height: 150px;"
                      >
                        <div class="demo-upload-list" v-if="form['zh-cn_detail_image'] != ''">
                          <template>
                            <img :src="form['zh-cn_detail_image']" />
                          </template>
                        </div>
                        <div v-else style="width: 300px;height:150px;line-height: 165px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{$t('photo_tip')+" 1638*550"}}</div>
                    </FormItem>-->
                </Col>
                <Col span="12">
                <FormItem prop="sort" :label="$t('sort')">
                  <InputNumber :min="1" v-model="form.sort"
                    :placeholder="tabs == 1 ? '请输入排序顺序' : tabs == 2 ? '請輸入排序順序' : 'Please enter the sort order'">
                  </InputNumber>
                </FormItem>
                <FormItem :label="$t('isHome')" prop="is_home">
                  <i-Switch size="large" v-model="form.is_home" true-value="1" false-value="0" />
                </FormItem>
                <FormItem :label="$t('status')" prop="status">
                  <i-Switch size="large" v-model="form.status" true-value="A2" false-value="A1" />
                </FormItem>
                <FormItem :label="$t('img_lnk') + ' - Mobile'" prop="zh-cn_mobile_head_image">
                  <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 7)"
                    type="drag" action style="display: inline-block;width:300px;height: 150px;">
                    <div class="demo-upload-list" v-if="form['zh-cn_mobile_head_image'] != ''">
                      <template>
                        <img :src="form['zh-cn_mobile_head_image']" />
                      </template>
                    </div>
                    <div v-else style="width: 300px;height:150px;line-height: 165px;">
                      <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                    </div>
                  </Upload>
                  <div class="photo_tip">{{ $t('photo_tip') + " 360*200" }}</div>
                  <div>
                    <Button type="primary" @click="onCopyImg(1)">{{ $t('Copy_language') }}</Button>
                  </div>
                </FormItem>
                <!-- <FormItem
                      :label="$t('Details_pictures')+' - Mobile' "
                      prop="zh-cn_mobile_detail_image"
                    >
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :before-upload="(value)=>handleBeforeUpload(value,10)"
                        type="drag"
                        action
                        style="display: inline-block;width:300px;height: 150px;"
                      >
                        <div
                          class="demo-upload-list"
                          v-if="form['zh-cn_mobile_detail_image'] != ''"
                        >
                          <template>
                            <img :src="form['zh-cn_mobile_detail_image']" />
                          </template>
                        </div>
                        <div v-else style="width: 300px;height:150px;line-height: 165px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{$t('photo_tip')+" 360*200"}}</div>
                    </FormItem>-->
                </Col>
                </Col>
                <Col span="24">
                <FormItem prop="zh-cn_content" :label="$t('content')">
                  <vue-editor v-model="form['zh-cn_content']" placeholder="请输入内容" :editor-toolbar="customToolbar"
                    :editorOptions="editorSettings" :customModules="customModulesForEditor"
                    @image-added="handleImageAdded" :useCustomImageHandler="true" />
                </FormItem>
                </Col>
              </TabPane>
              <TabPane :label="$t('Langue.tw')" name="2">
                <Col span="24" style="display: flex;">
                <Col span="12">
                <FormItem class="item_input" prop="zh-tw_title" :label="$t('title')">
                  <Input type="text" v-model="form['zh-tw_title']" placeholder="請輸入標題"></Input>
                </FormItem>
                <FormItem class="item_input" prop="zh-tw_brief" :label="$t('brief')">
                  <Input type="text" v-model="form['zh-tw_brief']" placeholder="請輸入簡介"></Input>
                </FormItem>
                <FormItem class="item_input" prop="author" :label="$t('author')">
                  <Input type="text" v-model="form.author" placeholder="請輸入作者"></Input>
                </FormItem>
                <FormItem :label="$t('img_lnk') + ' - PC'" prop="zh-tw_head_image">
                  <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 2)"
                    type="drag" action style="display: inline-block;width:300px;height: 150px;">
                    <div class="demo-upload-list" v-if="form['zh-tw_head_image'] != ''">
                      <template>
                        <img :src="form['zh-tw_head_image']" />
                      </template>
                    </div>
                    <div v-else style="width: 300px;height:150px;line-height: 165px;">
                      <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                    </div>
                  </Upload>
                  <div class="photo_tip">{{ $t('photo_tip') + " 1200 x 630" }}</div>
                  <div>
                    <Button type="primary" @click="onCopyImgPc(2)">{{ $t('Copy_language') }}</Button>
                  </div>
                </FormItem>
                <!-- <FormItem :label="$t('Details_pictures')+' - PC' " prop="zh-tw_detail_image">
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :before-upload="(value)=>handleBeforeUpload(value,5)"
                        type="drag"
                        action
                        style="display: inline-block;width:300px;height: 150px;"
                      >
                        <div class="demo-upload-list" v-if="form['zh-tw_detail_image'] != ''">
                          <template>
                            <img :src="form['zh-tw_detail_image']" />
                          </template>
                        </div>
                        <div v-else style="width: 300px;height:150px;line-height: 165px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{$t('photo_tip')+" 1638*550"}}</div>
                    </FormItem>-->
                </Col>
                <Col span="12">
                <FormItem prop="sort" :label="$t('sort')">
                  <InputNumber :min="1" v-model="form.sort"
                    :placeholder="tabs == 1 ? '请输入排序顺序' : tabs == 2 ? '請輸入排序順序' : 'Please enter the sort order'">
                  </InputNumber>
                </FormItem>
                <FormItem :label="$t('isHome')" prop="is_home">
                  <i-Switch size="large" v-model="form.is_home" true-value="1" false-value="0" />
                </FormItem>
                <FormItem :label="$t('status')" prop="status">
                  <i-Switch size="large" v-model="form.status" true-value="A2" false-value="A1" />
                </FormItem>
                <FormItem :label="$t('img_lnk') + ' - Mobile'" prop="zh-tw_mobile_head_image">
                  <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 8)"
                    type="drag" action style="display: inline-block;width:300px;height: 150px;">
                    <div class="demo-upload-list" v-if="form['zh-tw_mobile_head_image'] != ''">
                      <template>
                        <img :src="form['zh-tw_mobile_head_image']" />
                      </template>
                    </div>
                    <div v-else style="width: 300px;height:150px;line-height: 165px;">
                      <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                    </div>
                  </Upload>
                  <div class="photo_tip">{{ $t('photo_tip') + " 360*200" }}</div>
                  <div>
                    <Button type="primary" @click="onCopyImg(2)">{{ $t('Copy_language') }}</Button>
                  </div>
                </FormItem>
                <!-- <FormItem
                      :label="$t('Details_pictures')+' - Mobile' "
                      prop="zh-tw_mobile_detail_image"
                    >
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :before-upload="(value)=>handleBeforeUpload(value,11)"
                        type="drag"
                        action
                        style="display: inline-block;width:300px;height: 150px;"
                      >
                        <div
                          class="demo-upload-list"
                          v-if="form['zh-tw_mobile_detail_image'] != ''"
                        >
                          <template>
                            <img :src="form['zh-tw_mobile_detail_image']" />
                          </template>
                        </div>
                        <div v-else style="width: 300px;height:150px;line-height: 165px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{$t('photo_tip')+" 360*200"}}</div>
                    </FormItem>-->
                </Col>
                </Col>
                <Col span="24">
                <FormItem prop="zh-tw_content" :label="$t('content')">
                  <vue-editor v-model="form['zh-tw_content']" placeholder="請輸入內容" :editor-toolbar="customToolbar"
                    :editorOptions="editorSettings" :customModules="customModulesForEditor"
                    @image-added="handleImageAdded" :useCustomImageHandler="true" />
                </FormItem>
                </Col>
              </TabPane>
              <TabPane :label="$t('Langue.en')" name="3">
                <Col span="24" style="display: flex;">
                <Col span="12">
                <FormItem class="item_input" prop="en_title" :label="$t('title')">
                  <Input type="text" v-model="form.en_title" placeholder="Please enter title"></Input>
                </FormItem>
                <FormItem class="item_input" prop="en_brief" :label="$t('brief')">
                  <Input type="text" v-model="form.en_brief" placeholder="Please enter introduction"></Input>
                </FormItem>
                <FormItem class="item_input" prop="author" :label="$t('author')">
                  <Input type="text" v-model="form.author" placeholder="Please enter author"></Input>
                </FormItem>
                <FormItem :label="$t('img_lnk') + ' - PC'" prop="en_head_image">
                  <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 3)"
                    type="drag" action style="display: inline-block;width:300px;height: 150px;">
                    <div class="demo-upload-list" v-if="form.en_head_image != ''">
                      <template>
                        <img :src="form.en_head_image" />
                      </template>
                    </div>
                    <div v-else style="width: 300px;height:150px;line-height: 165px;">
                      <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                    </div>
                  </Upload>
                  <div class="photo_tip">{{ $t('photo_tip') + " 1200 x 630" }}</div>
                  <div>
                    <Button type="primary" @click="onCopyImgPc(3)">{{ $t('Copy_language') }}</Button>
                  </div>
                </FormItem>
                <!-- <FormItem :label="$t('Details_pictures')+' - PC' " prop="en_detail_image">
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :before-upload="(value)=>handleBeforeUpload(value,6)"
                        type="drag"
                        action
                        style="display: inline-block;width:300px;height: 150px;"
                      >
                        <div class="demo-upload-list" v-if="form.en_detail_image != ''">
                          <template>
                            <img :src="form.en_detail_image" />
                          </template>
                        </div>
                        <div v-else style="width: 300px;height:150px;line-height: 165px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{$t('photo_tip')+" 1638*550"}}</div>
                    </FormItem>-->
                </Col>
                <Col span="12">
                <FormItem prop="sort" :label="$t('sort')">
                  <InputNumber :min="1" v-model="form.sort"
                    :placeholder="tabs == 1 ? '请输入排序顺序' : tabs == 2 ? '請輸入排序順序' : 'Please enter the sort order'">
                  </InputNumber>
                </FormItem>
                <FormItem :label="$t('isHome')" prop="is_home">
                  <i-Switch size="large" v-model="form.is_home" true-value="1" false-value="0" />
                </FormItem>
                <FormItem :label="$t('status')" prop="status">
                  <i-Switch size="large" v-model="form.status" true-value="A2" false-value="A1" />
                </FormItem>
                <FormItem :label="$t('img_lnk') + ' - Mobile'" prop="en_mobile_head_image">
                  <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 9)"
                    type="drag" action style="display: inline-block;width:300px;height: 150px;">
                    <div class="demo-upload-list" v-if="form.en_mobile_head_image != ''">
                      <template>
                        <img :src="form.en_mobile_head_image" />
                      </template>
                    </div>
                    <div v-else style="width: 300px;height:150px;line-height: 165px;">
                      <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                    </div>
                  </Upload>
                  <div class="photo_tip">{{ $t('photo_tip') + " 360*200" }}</div>
                  <div>
                    <Button type="primary" @click="onCopyImg(3)">{{ $t('Copy_language') }}</Button>
                  </div>
                </FormItem>
                <!-- <FormItem
                      :label="$t('Details_pictures')+' - Mobile' "
                      prop="en_mobile_detail_image"
                    >
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :before-upload="(value)=>handleBeforeUpload(value,12)"
                        type="drag"
                        action
                        style="display: inline-block;width:300px;height: 150px;"
                      >
                        <div class="demo-upload-list" v-if="form.en_mobile_detail_image != ''">
                          <template>
                            <img :src="form.en_mobile_detail_image" />
                          </template>
                        </div>
                        <div v-else style="width: 300px;height:150px;line-height: 165px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{$t('photo_tip')+" 360*200"}}</div>
                    </FormItem>-->
                </Col>
                </Col>
                <Col span="24">
                <FormItem prop="en_content" :label="$t('content')">
                  <vue-editor v-model="form.en_content" placeholder="Please enter the content"
                    :editor-toolbar="customToolbar" :editorOptions="editorSettings"
                    :customModules="customModulesForEditor" @image-added="handleImageAdded"
                    :useCustomImageHandler="true" />
                </FormItem>
                </Col>
              </TabPane>
            </Row>
          </Tabs>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { VueEditor, Quill } from 'vue2-editor'
// 导入图片操作相关插件
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
export default {
  components: {
    VueEditor
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
    type: String
  },
  data () {
    const validateImg = (rule, value, callback) => {
      if (value == '') {
        callback(new Error(this.$t('p_upload_img')));
      } else {
        callback();
      }
    };
    return {
      tabs: '1',
      form: {
        blog_id: "",
        author: "",
        en_title: "",
        en_brief: "",
        en_content: "",
        en_head_image: "",
        en_detail_image: "",
        en_mobile_head_image: "",
        en_mobile_detail_image: "",
        "zh-cn_title": "",
        "zh-cn_brief": "",
        "zh-cn_content": "",
        "zh-cn_head_image": "",
        "zh-cn_detail_image": "",
        "zh-cn_mobile_head_image": "",
        "zh-cn_mobile_detail_image": "",
        "zh-tw_title": "",
        "zh-tw_brief": "",
        "zh-tw_content": "",
        "zh-tw_head_image": "",
        "zh-tw_detail_image": "",
        "zh-tw_mobile_head_image": "",
        "zh-tw_mobile_detail_image": "",
        status: "A1",
        is_home: "0",
        sort: 1,
      },
      ruleInline: {
        author: [
          {
            required: true,
            message: this.$t("author_input"),
            trigger: "blur"
          }
        ],
        'zh-cn_title': [
          {
            required: true,
            message: this.$t("title_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_title': [
          {
            required: true,
            message: this.$t("title_input"),
            trigger: "blur"
          }
        ],
        en_title: [
          {
            required: true,
            message: this.$t("title_input"),
            trigger: "blur"
          }
        ],
        'zh-cn_brief': [
          {
            required: true,
            message: this.$t("brief_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_brief': [
          {
            required: true,
            message: this.$t("brief_input"),
            trigger: "blur"
          }
        ],
        en_brief: [
          {
            required: true,
            message: this.$t("brief_input"),
            trigger: "blur"
          }
        ],
        'zh-cn_content': [
          {
            required: true,
            message: this.$t("content_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_content': [
          {
            required: true,
            message: this.$t("content_input"),
            trigger: "blur"
          }
        ],
        en_content: [
          {
            required: true,
            message: this.$t("content_input"),
            trigger: "blur"
          }
        ],
        "zh-cn_head_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-tw_head_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_head_image: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-cn_detail_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-tw_detail_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_detail_image: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-cn_mobile_head_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-cn_mobile_detail_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-tw_mobile_head_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-tw_mobile_detail_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_mobile_head_image: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_mobile_detail_image: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        status: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        is_home: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        sort: [
          {
            type: 'number',
            required: true,
            message: this.$t('sort_input'),
            trigger: 'blur'
          }
        ],
      },
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'align': ['', 'center', 'right', 'justify'] }],
        ['blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        ['link', 'clean'],
        ["image", "video"]                             // remove formatting button
      ],
      // 设置编辑器图片可拖拽
      editorSettings: {
        modules: { imageDrop: true, imageResize: {} }
      },
      customModulesForEditor: [
        { alias: "imageDrop", module: ImageDrop },
        { alias: "imageResize", module: ImageResize }
      ],
      show: this.modal
    }

  },
  created () {
    this.info()
  },
  mounted () {

  },
  methods: {
    info () {
      this.form.ad_id = this.$base.getRequest().id
      if (this.type != 'add') {
        this.$base.showLoading();
        this.$request.sendPost(
          'blog/before-upd',
          { blog_id: this.itemObj.blog_id },
          (success, data, error) => {
            this.$base.hideLoading();
            if (!success) return this.$base.alertErr(error.errmsg);
            if (data.info.en_content.substr(0, 4) == '<div') {
              // data.info.en_content = data.info.en_content.replace('<div', '<p')
              // data.info.en_content = data.info.en_content.replace('</div>', '</p>')
              data.info.en_content  = data.info.en_content .substr(4, data.info.en_content .length - 5)
              data.info.en_content = '<p' + data.info.en_content + '</p>'
            }
            if (data.info['zh-cn_content'].substr(0, 4) == '<div') {
              data.info['zh-cn_content'] = data.info['zh-cn_content'].substr(4, data.info['zh-cn_content'].length - 5)
              data.info['zh-cn_content'] = '<p' + data.info['zh-cn_content'] + '</p>'
            }
            if (data.info['zh-tw_content'].substr(0, 4) == '<div') {
              // data.info['zh-tw_content'] = data.info['zh-tw_content'].replace('<div', '<p')
              // data.info['zh-tw_content'] = data.info['zh-tw_content'].replace('</div>', '</p>')
              data.info['zh-tw_content'] = data.info['zh-tw_content'].substr(4, data.info['zh-tw_content'].length - 5)
              data.info['zh-tw_content'] = '<p' + data.info['zh-tw_content'] + '</p>'
            }
            this.form = data.info
            this.form.sort = this.form.sort * 1
          }
        );
      }
    },
    onCopyImgPc (num) {
      switch (num) {
        case 1:
          if (this.form['zh-cn_head_image'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-tw_head_image'] = this.form['zh-cn_head_image']
          this.form['en_head_image'] = this.form['zh-cn_head_image']
          break;
        case 2:
          if (this.form['zh-tw_head_image'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-cn_head_image'] = this.form['zh-tw_head_image']
          this.form['en_head_image'] = this.form['zh-tw_head_image']
          break;
        case 3:
          if (this.form['en_head_image'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-cn_head_image'] = this.form['en_head_image']
          this.form['zh-tw_head_image'] = this.form['en_head_image']
          break;
      }
    },
    onCopyImg (num) {
      switch (num) {
        case 1:
          if (this.form['zh-cn_mobile_head_image'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-tw_mobile_head_image'] = this.form['zh-cn_mobile_head_image']
          this.form['en_mobile_head_image'] = this.form['zh-cn_mobile_head_image']
          break;
        case 2:
          if (this.form['zh-tw_mobile_head_image'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-cn_mobile_head_image'] = this.form['zh-tw_mobile_head_image']
          this.form['en_mobile_head_image'] = this.form['zh-tw_mobile_head_image']
          break;
        case 3:
          if (this.form['en_mobile_head_image'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-cn_mobile_head_image'] = this.form['en_mobile_head_image']
          this.form['zh-tw_mobile_head_image'] = this.form['en_mobile_head_image']
          break;
      }

    },
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    ontabs (item) {
      this.tabs = item
    },
    // 自定义图片上传
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      this.$base.showLoading();
      this.$base.uploadPicimg(file, file.name).then(res => {
        this.$base.hideLoading();
        if (res.url) {
          Editor.insertEmbed(cursorLocation, "image", res.url);
          resetUploader();
        }
      });

    },
    handleBeforeUpload (file, num) {
      this.$base.showLoading();
      this.$base.uploadPicimg(file, '').then(res => {
        this.$base.hideLoading();
        if (res.url) {
          switch (num) {
            case 1:
              this.form['zh-cn_head_image'] = res.url
              break;
            case 2:
              this.form['zh-tw_head_image'] = res.url
              break;
            case 3:
              this.form.en_head_image = res.url
              break;
            case 4:
              this.form['zh-cn_detail_image'] = res.url
              break;
            case 5:
              this.form['zh-tw_detail_image'] = res.url
              break;
            case 6:
              this.form.en_detail_image = res.url
              break;
            case 7:
              this.form['zh-cn_mobile_head_image'] = res.url
              break;
            case 8:
              this.form['zh-tw_mobile_head_image'] = res.url
              break;
            case 9:
              this.form.en_mobile_head_image = res.url
              break;
            case 10:
              this.form['zh-cn_mobile_detail_image'] = res.url
              break;
            case 11:
              this.form['zh-tw_mobile_detail_image'] = res.url
              break;
            case 12:
              this.form.en_mobile_detail_image = res.url
              break;
          }
        }
      });
    },
    submit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$base.showLoading();
          this.$request.sendPost(
            this.type == 'add' ? 'blog/add' : 'blog/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$emit('onOk');
            }
          );
        } else {
          this.error()
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .list {
    width: 100%;
    padding: 30px;
  }

  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }

  .demo-upload-list {
    display: inline-block;
    width: 300px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }

  .ivu-upload-drag {
    height: 150px;
  }

  .ivu-btn-small {
    height: 24px;
    padding: 0 7px;
    font-size: 14px;
    border-radius: 3px;
  }

  .ivu-tabs {
    overflow: inherit;
  }

  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }

  .ql-editor {
    height: 500px;
  }

  .photo_tip {
    color: #c5c8ce;
    font-size: 13px;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/edu/blog/module/blog_edit.vue